import { render, staticRenderFns } from "./chatPage.vue?vue&type=template&id=0a36e33d&scoped=true&"
import script from "./chatPage.vue?vue&type=script&lang=js&"
export * from "./chatPage.vue?vue&type=script&lang=js&"
import style0 from "./chatPage.vue?vue&type=style&index=0&id=0a36e33d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36e33d",
  null
  
)

export default component.exports